import { formatEUR, STATUS_LABELS } from "../lib/apiClient";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";

const Delta = ({ before, after }) => {
  const d = after - before;
  return (
    <span className="font-mono text-xs whitespace-nowrap">
      {formatEUR(before)} → {formatEUR(after)}{" "}
      <span className={d > 0 ? "text-rose-700" : "text-emerald-700"}>({d > 0 ? "+" : ""}{formatEUR(d)})</span>
    </span>
  );
};

const Block = ({ title, testId, children }) => (
  <div data-testid={testId}>
    <p className="label-eyebrow mb-2">{title}</p>
    <div className="border border-zinc-200 divide-y divide-zinc-100">{children}</div>
  </div>
);

export const RestaurantChangePreview = ({ preview, onCancel, onConfirm, saving }) => (
  <Dialog open={!!preview} onOpenChange={(v) => !v && onCancel()}>
    <DialogContent className="rounded-none max-w-2xl" data-testid="change-preview-dialog">
      <DialogHeader>
        <DialogTitle className="font-heading text-2xl">Este cambio afecta a facturas emitidas o pagadas</DialogTitle>
        <DialogDescription>Las facturas emitidas o pagadas no cambian. La diferencia se factura como extra o se descuenta de la siguiente factura pendiente.</DialogDescription>
      </DialogHeader>
      {preview && (
        <div className="space-y-5 max-h-[55vh] overflow-y-auto pr-1 text-sm">
          {preview.affected.length > 0 && (
            <Block title="Facturas emitidas / pagadas afectadas" testId="preview-affected">
              {preview.affected.map((a) => (
                <div key={a.slot} className="px-3 py-2">
                  <div className="flex justify-between gap-3">
                    <span className="font-medium">{a.label}</span>
                    <span className="text-xs text-zinc-500">Nuevo cálculo <Delta before={a.target_before} after={a.target_after} /></span>
                  </div>
                  {a.invoices.map((i) => (
                    <p key={i.id} className="text-xs text-zinc-500 font-mono">{i.label} · {STATUS_LABELS[i.status]} · {formatEUR(i.amount_due)}</p>
                  ))}
                </div>
              ))}
            </Block>
          )}
          {preview.extras.length > 0 && (
            <Block title="Extras cambio en datos restaurantes" testId="preview-extras">
              {preview.extras.map((x) => (
                <div key={x.slot} className="px-3 py-2 flex justify-between gap-3">
                  <span>{x.label}</span><Delta before={x.before} after={x.after} />
                </div>
              ))}
            </Block>
          )}
          {preview.discounts.length > 0 && (
            <Block title="Descuentos en facturas pendientes" testId="preview-discounts">
              {preview.discounts.map((x) => (
                <div key={x.slot} className="px-3 py-2 flex justify-between gap-3">
                  <span>{x.label}</span><Delta before={x.before} after={x.after} />
                </div>
              ))}
            </Block>
          )}
        </div>
      )}
      <DialogFooter>
        <Button variant="outline" onClick={onCancel} className="rounded-none" data-testid="preview-cancel-button">Cancelar</Button>
        <Button onClick={onConfirm} disabled={saving} className="rounded-none bg-zinc-900 hover:bg-zinc-800" data-testid="preview-confirm-button">Guardar igualmente</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
